import { render } from "./PropertyDialog.vue?vue&type=template&id=425b8b5b&ts=true"
import script from "./PropertyDialog.vue?vue&type=script&lang=ts"
export * from "./PropertyDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__